import React, { Component } from 'react'
import PropTypes from 'prop-types'

// CSS
import './NavigationMobile.css'

class NavigationMobile extends Component {

    static propTypes = {
        currentActiveMenu: PropTypes.string,
        menuOpen: PropTypes.bool.isRequired,
        onToggleMenu: PropTypes.func.isRequired
    }

    render() {

        const currentActiveMenu = this.props.currentActiveMenu ? this.props.currentActiveMenu : 'menu'

        return (
            <nav className="navigation mobile">
                <button onClick={this.handleToggleMenu}>{currentActiveMenu} <span className="navigation-menu-state">{!this.props.menuOpen ? '▼' : '▲'}</span></button>

                {this.props.menuOpen ? <ul onClick={this.handleToggleMenu}>
                    {this.props.children}
                </ul> : null}
            </nav>
        )
    }

    handleToggleMenu = () => {
        this.props.onToggleMenu()
    }
}

export default NavigationMobile;



// WEBPACK FOOTER //
// ./src/components/header/navigationMobile/NavigationMobile.js